import React, { useEffect, useState } from 'react';
import { PageSubTitle, PageTitle } from 'styles/Global/commonStyles';
import { HospitalPageLabel, FilterWrapper, DiagnosisInnerLayout, DiagnosisLayout, DiagnosisTapsContainer, DiagnosisItemButton } from 'styles/Global/hospitalStyles';
import useToggle from 'hooks/CustomHooks/useToggle';
import moment from 'moment';
import { diagnosisPaginationSorting } from 'functions/paginationSorting';
import usePaginationStateHooks from 'hooks/CustomHooks/usePaginationStateHooks';
import { useLoginStore } from 'store/useLoginDataStore';
import { RoundBadgeSelectS } from 'components/Common/Badge';
import { DiagnosisStatus } from 'utils/statusCode';
import _ from 'lodash';
import BasicConfirmModal from 'components/Modal/BasicConfirmModal';
import { getConsultationTypeStr } from 'utils/hospitalUtils';
import { ReservationType } from '../MindUpAdminDiagnosisListPage/MindUpAdminConsultationListPage';
import TodayDiagnosisFilter from 'pages/DCK/TodayDiagnosisPage/TodayDiagnosisFilter';
import MindUpAdminDiagnosisListPagination from '../MindUpAdminDiagnosisListPage/MindUpAdminDiagnosisListPagination';
import TodayDiagnosisSlider from 'pages/DCK/TodayDiagnosisPage/TodayDiagnosisSlider';
import diagnosisPaginationSearchFilter from 'functions/diagnosisPaginationSearchFilter';
import { useDiagnosisListQuery } from 'api/Queries/Diagnosis/useDiagnosisListQuery';
import { todayDiagnosisMenuList } from './constants';
import { IDDiagnosis, IDDiagnosisNull } from 'models/DCK/basicInterface';
import { addNoShowDisabledField } from '../utils/mindUpAdminFunctions';
import FillOutDialogueSchedule from 'components/DesignSystem/Modal/FillOutDialogueSchedule';
import { useDialogueScheduleHooks } from 'hooks/CustomHooks/useDialogueScheduleHooks';
import useDiagnosisUpdateMutation from 'api/Mutations/Diagnosis/useDiagnosisUpdateMutation';
import { DiagnosisUpdateReqeustType } from 'models/DCK/DCKApiTypes';
import { DCKDiagnosisApi } from 'api/DCK/DCKDiagnosisApi';

const MindUpAdminTodayDiagnosisPage = () => {
    const { loginData } = useLoginStore();

    const [initData, setInitData] = useState<IDDiagnosis[]>();
    const [slideData, setSlideData] = useState<IDDiagnosis[]>();
    const [filterData, setFilterData] = useState<IDDiagnosis[] | undefined>(initData);
    const [selectedSearchFilter, setselectedSearchFilter] = useState<number>(0);
    const [searchValue, setSearchValue] = useState<string>('');
    const [sortField, setSortField] = useState<string>('');
    const [sortDirections, setSortDirections] = useState<Record<string, boolean>>({ patientName: false, patientIdentityNumber: false, diagnosisDateTime: false, status: false, doctorName: false });
    const [paginationMenu, setPaginationMenu] = useState(0);
    const [counselData, setCounselData] = useState<ReservationType>();
    const [devideDiagnosisProcess, setDevideDiagnosisProcess] = useState({ ALL: 0, COUNSEL_RESERVED: 0, COUNSEL_COMPLETE: 0 });

    const [isSearchFilterDropdown, setIsSearchFilterDropdown] = useToggle();
    const [isShowConfirmModal, setIsShowConfrimModal] = useToggle();
    // const [onDialogueScheduleModal, setOnDialogueScheduleModal] = useToggle();

    const { totalPages, setPage, currentPage, pageGroup, handlePageGroup, currentData } = usePaginationStateHooks(filterData);
    const {
        selectedDate,
        setSelectedDate,
        selectedTime,
        setSelectedTime,
        selectedDialogueScheduleData,
        onDialogueScheduleModal,
        initDate,
        onChangeDiagnosisDateModal,
        closeFillOutDialogueScheduleModal,
        getRqDataUpdateDiagnosisInfo,
    } = useDialogueScheduleHooks();

    const {
        data: diagnosisListData,
        isLoading: diagnosisListLoading,
        refetch: refetchDiagnosisListData,
    } = useDiagnosisListQuery(moment().format('YYYYMMDD'), moment().format('YYYYMMDD'), paginationMenu);
    const { mutate: diagnosisUpdate } = useDiagnosisUpdateMutation();

    useEffect(() => {
        processDiagnosisData();
        handleResetButton();
    }, [diagnosisListData]);

    const processDiagnosisData = () => {
        if (!diagnosisListData) {
            return;
        }

        const counselReservedList = (counselItem: IDDiagnosis) => counselItem.status === DiagnosisStatus.counselReserved;
        const counselCompleteList = (counselItem: IDDiagnosis) => counselItem.status === DiagnosisStatus.counselComplete;

        let paginationMenuCount = { ALL: 0, COUNSEL_RESERVED: 0, COUNSEL_COMPLETE: 0 };

        let todayDiagnosisData = diagnosisListData.filter((data) => data.status >= DiagnosisStatus.counselReserved && data.doctorId === loginData.id);

        paginationMenuCount.ALL = todayDiagnosisData?.length || 0;

        todayDiagnosisData.filter((item) => (item.status === DiagnosisStatus.counselReserved ? paginationMenuCount.COUNSEL_RESERVED++ : paginationMenuCount.COUNSEL_COMPLETE++));

        todayDiagnosisData = addNoShowDisabledField(todayDiagnosisData);

        // TODO: 추후 sorting 기능 원복 필요 시 아래 주석 해제(지금 현재 Figma 오름차순 정렬)
        const sortedData =
            paginationMenu !== 0
                ? todayDiagnosisData.filter(paginationMenu === 1 ? counselReservedList : counselCompleteList).sort((a, b) => a.diagnosisDateTime.localeCompare(b.diagnosisDateTime))
                : todayDiagnosisData.sort((a, b) => a.diagnosisDateTime.localeCompare(b.diagnosisDateTime));

        setSortField('diagnosisDateTime');
        setSortDirections((prev) => ({
            ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
            diagnosisDateTime: true,
        }));

        setDevideDiagnosisProcess(paginationMenuCount);
        setInitData(sortedData);
        setFilterData(sortedData);
        setSlideData([...todayDiagnosisData].sort((a, b) => a.diagnosisDateTime.localeCompare(b.diagnosisDateTime)));
    };

    const handleDropdown = (e: React.MouseEvent, idx: number, type: string) => {
        e.stopPropagation();
        setIsSearchFilterDropdown();
        setselectedSearchFilter(idx);
        setSearchValue('');
        setPage(1);
    };

    // SearchFilter function
    const handleSearchFilter = () => {
        diagnosisPaginationSearchFilter(searchValue, setSortDirections, setSortField, selectedSearchFilter, initData, setPage, handlePageGroup, setFilterData, 'mindUpAdmin');
    };

    // sorting function
    const handleSorting = (type: string) => {
        const direction = !sortDirections[type];

        setSortField(type);
        setSortDirections((prev) => ({
            ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
            [type]: direction,
        }));
        setFilterData(diagnosisPaginationSorting(type, filterData || [], direction));
    };

    // reset Button function
    const handleResetButton = () => {
        setSearchValue('');
        setPage(1);
        handlePageGroup(0);
        setSortDirections((prev) => ({
            ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
            diagnosisDateTime: true,
        }));
        setSortField('diagnosisDateTime');
        setCounselData({ diagnosisId: '', reservationDate: '' });
        setselectedSearchFilter(0);
        // refetchDiagnosisListData();
    };

    // 상담 완료 함수
    const setCounselComplete = async () => {
        if (!counselData?.diagnosisId) {
            return;
        }

        const changeStatusRqData = {
            _id: counselData!.diagnosisId,
            status: DiagnosisStatus.counselComplete,
        };

        await DCKDiagnosisApi.changeDiagnosisStatus(changeStatusRqData, loginData.token);
        setIsShowConfrimModal();
        handleResetButton();
        refetchDiagnosisListData();
    };

    // 진료 정보 update
    const handleDiagnosisUpdate = async () => {
        const rqData = getRqDataUpdateDiagnosisInfo();
        diagnosisUpdate(rqData as DiagnosisUpdateReqeustType, {
            onSuccess: (data) => {
                closeFillOutDialogueScheduleModal();
                refetchDiagnosisListData();
            },
            onError: (error) => {
                console.error('진단 정보 업데이트 실패', error);
            },
        });
    };

    // 상담 일시 확정 모달 및 id 넣기
    const handleShowConfirmModal = (diagnosisInfo?: IDDiagnosisNull) => {
        if (diagnosisInfo?.status !== DiagnosisStatus.counselComplete) {
            setIsShowConfrimModal();
            setCounselData({ diagnosisId: diagnosisInfo?._id!, reservationDate: '' });
        }
    };

    return (
        <DiagnosisLayout>
            {onDialogueScheduleModal && (
                <FillOutDialogueSchedule
                    diagnosisInfo={selectedDialogueScheduleData!}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    initDate={initDate}
                    selectedTime={selectedTime}
                    setSelectedTime={setSelectedTime}
                    onModalClose={closeFillOutDialogueScheduleModal}
                    updateDiagnosisInfoApiCall={handleDiagnosisUpdate}
                    label='상담 일시'
                    title='상담 일시 변경'
                />
            )}
            {isShowConfirmModal && (
                <BasicConfirmModal
                    title='상담을 완료하셨나요?'
                    content='상담을 끝내셨다면, 완료 처리해주세요.'
                    cancelButton={setIsShowConfrimModal}
                    confirmButton={setCounselComplete}
                    firstButton='취소'
                    secondButton='상담 완료'
                />
            )}
            {!currentData || diagnosisListLoading ? null : (
                <DiagnosisInnerLayout>
                    <HospitalPageLabel onClick={() => window.location.reload()}>오늘 나의 상담 </HospitalPageLabel>
                    <PageTitle $marginbottom='24px'>
                        {`${moment().format('YYYY년 MM월 DD일 dddd')}`}
                        <PageSubTitle> {getConsultationTypeStr(loginData.level)}</PageSubTitle>
                    </PageTitle>
                    {(!slideData || slideData?.length !== 0) && (
                        <TodayDiagnosisSlider data={slideData} onProcessButtonClick={handleShowConfirmModal} onChangeDiagnosisDateModal={onChangeDiagnosisDateModal} />
                    )}
                    <DiagnosisTapsContainer $topMargin={'40px'} $bottomMargin={'16px'}>
                        {todayDiagnosisMenuList.map((item, idx) => {
                            return (
                                <DiagnosisItemButton key={idx} onClick={() => setPaginationMenu(idx)} $idx={idx} $selected={paginationMenu === idx ? paginationMenu : undefined}>
                                    {item}
                                    <RoundBadgeSelectS $selected={paginationMenu === idx}>
                                        {idx === 0 ? devideDiagnosisProcess.ALL : idx === 1 ? devideDiagnosisProcess.COUNSEL_RESERVED : devideDiagnosisProcess.COUNSEL_COMPLETE}
                                    </RoundBadgeSelectS>
                                </DiagnosisItemButton>
                            );
                        })}
                    </DiagnosisTapsContainer>
                    <FilterWrapper>
                        <TodayDiagnosisFilter
                            diagnosisNumber={filterData?.length}
                            selectedSearchFilter={selectedSearchFilter}
                            handleDropdown={handleDropdown}
                            isSearchFilterDropdown={isSearchFilterDropdown}
                            setIsSearchFilterDropdown={setIsSearchFilterDropdown}
                            onChange={setSearchValue}
                            searchValue={searchValue}
                            handleSearchFilter={handleSearchFilter}
                            type='mindupTodayDiagnosis'
                        />
                    </FilterWrapper>
                    <MindUpAdminDiagnosisListPagination
                        initNumber={initData?.length}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        pageGroup={pageGroup}
                        handlePageGroup={handlePageGroup}
                        handlePageChange={setPage}
                        currentData={currentData}
                        handleSorting={handleSorting}
                        sortField={sortField}
                        sortDirections={sortDirections}
                        handleCounselData={setCounselData}
                        handleResetButton={handleResetButton}
                        handleCounselCompleteAlert={setIsShowConfrimModal}
                        onChangeDiagnosisDateModal={onChangeDiagnosisDateModal}
                    />
                </DiagnosisInnerLayout>
            )}
        </DiagnosisLayout>
    );
};

export default MindUpAdminTodayDiagnosisPage;
